<div class="progress-bar-section columns is-vcentered is-centered is-gapless is-mobile">
  <div *ngIf="stepNumber !== 0" class="progress-bar-content column is-full">
    <div class="progress-bar-text">
      {{getText()}}
    </div>
    <div class="progress-bar">
      <div class="circle is-first is-colored" [class.is-in-progress]="stepNumber == 1" [class.is-colored]="stepNumber > 1"></div>
      <div class="circle is-second" [class.is-in-progress]="stepNumber == 2" [class.is-colored]="stepNumber > 2"></div>
      <div class="circle is-third" [class.is-in-progress]="stepNumber == 3" [class.is-colored]="stepNumber > 3"></div>
      <div class="circle is-fourth" [class.is-in-progress]="stepNumber == 4" [class.is-colored]="stepNumber > 4"></div>
      <div class="rectangle is-first" [class.is-colored]="stepNumber > 1"></div>
      <div class="rectangle is-second" [class.is-colored]="stepNumber > 2"></div>
      <div class="rectangle is-third" [class.is-colored]="stepNumber > 3"></div>
    </div>
  </div>
</div>
